const isMobile = function () {
    return (
        navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.userAgent.match(/IEMobile/i)
    );
};

export { isMobile };
